import { __decorate } from "tslib";
import { injectable } from 'inversify';
var LocalisationService = /** @class */ (function () {
    function LocalisationService() {
    }
    LocalisationService.prototype.getSupportedCultures = function () {
        return Promise.resolve([{
                language: "Default",
                cultureCode: ""
            }]);
    };
    LocalisationService = __decorate([
        injectable()
    ], LocalisationService);
    return LocalisationService;
}());
export default LocalisationService;
